import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import Button from 'uikit/Button/Button';
import { ReactComponent as ContactUsIcon } from 'assets/contact-us-icon.svg';
import './NoMessagesPlug.scss';

const NoMessagesPlug = ({ handleClickNewMessageButton, showWriteNewMessage }) => {
  const i18n = useContext(i18nContext);

  return (
    <div className={'messages-empty-container'}>
      <div className={'messages-empty-wrapper'}>
        <div>
          <ContactUsIcon />
        </div>
        <span className={'messages-empty-header'}>{i18n.getMessage('messages.empty.header')}</span>
        <span className={'messages-empty-body'}>{i18n.getMessage('messages.empty.body')}</span>
        {showWriteNewMessage && (
          <Button
            className={'messages-empty-button'}
            type={'primary'}
            onClick={handleClickNewMessageButton}
            roleType={'button'}
            size={'large'}
          >
            {i18n.getMessage('messages.button.writeNewMessage')}
          </Button>
        )}
      </div>
    </div>
  );
};

NoMessagesPlug.propTypes = {
  handleClickNewMessageButton: PropTypes.func.isRequired,
  showWriteNewMessage: PropTypes.bool.isRequired
};

export default NoMessagesPlug;
